import Translator from 'translator';
import Config from 'conf';
import { Logger, Toastr } from 'data/common';

const io = require('socket.io-client');
const util = require('util');
const { EventEmitter } = require('events');

let middlewareSocket = null;
let middlewareConfig = {
    host: null,
    options: {},
    port: null,
    protocol: 'http'
};

function SocketMiddleware(_dispatch, _getState, token) {
    if (_dispatch && token) {
        EventEmitter.call(this);
        this.dispatch = _dispatch;
        this.getState = _getState;
        this.timeout_connexion = setTimeout(() => {
            this.emit('cnx_error', 'error.socket.timeout_connexion');
            this.destroy();
        }, Config.timeout_socket);

        Logger.debug('Création Socket', `${middlewareConfig.protocol}://${middlewareConfig.host}:${middlewareConfig.port}`, {
            timeout: 10000,
            ...middlewareConfig.options,
            query: `type=client&authid=${token}`
        });

        this.socket = io(`${middlewareConfig.protocol}://${middlewareConfig.host}:${middlewareConfig.port}`, {
            timeout: 10000,
            ...middlewareConfig.options,
            query: `type=client&authid=${token}`
        });
        Logger.log('Lancement de la connexion au Middleware');
        this.bindSocketEvents();
    }
}

util.inherits(SocketMiddleware, EventEmitter);

SocketMiddleware.prototype.dispatch = function dispatch(action) {
    try {
        return this.dispatch(action);
    } catch (e) {
        return null;
    }
};

SocketMiddleware.prototype.bindSocketEvents = function bindSocketEvents() {
    if (!this.socket) {
        Logger.warn("Problème, la socket n'existe pas vraiment !");
        return false;
    }

    this.socket.on('error', (...args) => {
        const errorCode = args.message || args[0];
        let errorString = errorCode;
        Logger.log(`socket.error.${errorCode}`);
        if (Translator.isTranslationExist(`socket.error.${errorCode}`)) {
            errorString = Translator.translate(`socket.error.${errorCode}`);
            Toastr.error(errorString);
            Logger.log('Error Middleware', errorString);
        } else {
            Logger.log(`Error Middleware ${errorCode}`);
        }
        if (!this.getState().data.waiting_connection)
            this.dispatch({
                type: 'SET_WAITING_CONNECTION_STATE',
                waiting_connexion: true
            });

        // En cas d'erreur d'authentification on déconnecte l'utilisateur
        if (errorCode && errorCode.startsWith('FC_AUTH')) {
            this.emit('cnx_error', errorString);
            this.dispatch({ type: 'LOGOUT_USER' });
            this.dispatch({
                type: 'SET_LOGIN_PAGE_MESSAGE',
                message: errorString
            });
            this.destroy();
        }
    });

    this.socket.on('connect', () => {
        clearTimeout(this.timeout_connexion);
        this.timeout_connexion = null;
        Logger.log("L'application vient de se connecter au middleware FHE");
        this.emit('connected');
        if (this.getState().data.waiting_connection)
            this.dispatch({
                type: 'SET_WAITING_CONNECTION_STATE',
                waiting_connexion: false
            });
    });

    this.socket.on('disconnect', () => {
        Logger.log("L'application vient de se déconnecter du middleware FHE");
        if (!this.getState().data.waiting_connection)
            this.dispatch({
                type: 'SET_WAITING_CONNECTION_STATE',
                waiting_connexion: true
            });
    });

    return true;
};

SocketMiddleware.prototype.emitSocket = function emitSocket(event, params) {
    if (this.socket) {
        try {
            this.socket.emit('myFHE_event', event, params);
            Logger.log(`Socket Event Emitted ${event} : ${JSON.stringify(params)}`);
        } catch (e) {
            Logger.log(`Error emit socket event ${event} : ${e.message}`);
        }
    } else {
        Toastr.error(Translator.translate('error.socket.disconnected'));
    }
};

SocketMiddleware.prototype.destroy = function destroy() {
    try {
        Logger.log('Destruction socketMiddleware');
        if (this.socket) {
            // TODO Prevent crash
            this.socket.disconnect();
        } else {
            Logger.log('Impossible de déconnecter la socket');
        }
    } catch (e) {
        Logger.warn(e);
    }
    middlewareSocket = null;
    this.socket = null;
};

export default function(dispatch, getState, token, _middlewareConfig) {
    if (_middlewareConfig) {
        middlewareConfig = _middlewareConfig;
    }
    if (!middlewareSocket && dispatch && token) {
        middlewareSocket = new SocketMiddleware(dispatch, getState, token);
        Logger.log('Instanciation de la socket');
        return middlewareSocket;
    }

    return middlewareSocket;
}



// WEBPACK FOOTER //
// ./data/common/SocketMiddleware.js